export const routeTableSampleTotalStatus = {
  name: "total",
  value: "total",
  count: [
    312819, 255000, 304863, 551680, 486239, 408447, 506689, 488260, 271900,
    315206, 418432, 363844, 544370, 542287, 471476, 304139, 308769, 423561,
    590576, 554824, 535990, 500165, 245929, 310457, 518932, 571431, 590988,
    542077, 453800, 159349, 114751, 417302, 545904, 552714, 505895, 476681,
    217645, 313024, 656222, 628895, 597944, 519957, 454817, 234883, 271444,
    547390, 532553, 546908, 499274, 483758, 316157, 321164, 544026, 530074,
    540078, 374428, 411904, 275724, 258213, 524183, 493780, 556090, 514034,
    476804, 240475, 250997, 526819, 520252, 536037, 468596, 458580, 257217,
    306146, 487577, 561031, 572487, 446867, 260729, 91394, 100816, 294425,
    346849, 351432, 337503, 288148, 95581, 104005, 221047, 338442, 420575,
    321373,
  ],
  mean: [
    52.238, 57.755, 58.479, 49.714, 48.78, 49.181, 60.445, 66.178, 73.297,
    72.07, 57.744, 53.651, 61.853, 61.347, 61.408, 76.061, 75.715, 69.543,
    63.303, 64.558, 66.629, 68.237, 73.852, 84.772, 61.699, 61.262, 61.856,
    65.885, 65.695, 72.435, 70.38, 60.629, 65.267, 64.403, 64.96, 65.152,
    66.459, 60.248, 56.863, 60.989, 57.316, 57.988, 61.536, 69.56, 69.477,
    65.146, 61.887, 61.688, 62.919, 65.635, 73.086, 73.412, 63.566, 66.309,
    60.774, 61.119, 64.467, 70.818, 68.312, 61.063, 60.212, 60.993, 60.07,
    60.89, 66.996, 66.006, 60.882, 59.742, 62.05, 59.68, 63.231, 69.072, 70.06,
    60.467, 59.932, 60.724, 55.992, 51.48, 59.693, 60.302, 51.42, 51.428,
    52.107, 51.704, 52.929, 64.455, 60.217, 50.572, 47.716, 68.889, 62.355,
  ],
  p50: [
    49.76, 56.71, 57.05, 47.035, 44.254, 42.544, 51.723, 54.874, 62.893, 62.197,
    46.01, 40.192, 51.879, 50.649, 51.238, 63.739, 65.435, 57.876, 52.515,
    55.13, 56.565, 55.684, 62.473, 57.207, 51.075, 50.08, 51.969, 54.37, 52.475,
    60.052, 54.361, 45.319, 52.407, 52.509, 50.737, 53.874, 56.964, 51.911,
    46.1, 48.589, 48.801, 48.483, 51.509, 60.444, 61.131, 53.892, 50.152,
    53.834, 52.668, 55.286, 63.384, 62.751, 53.059, 50.248, 51.106, 52.343,
    54.672, 60.896, 59.573, 51.291, 49.59, 51.862, 50.995, 50.989, 58.393,
    57.987, 51.117, 47.923, 52.928, 49.041, 53.103, 58.43, 59.545, 50.265,
    49.991, 50.835, 45.628, 37.065, 43.508, 46.182, 34.539, 34.363, 41.508,
    34.69, 38.084, 50.97, 48.035, 33.985, 32.132, 38.824, 50.771,
  ],
  p90: [
    87.337, 86.832, 87.374, 82.813, 81.006, 84.91, 110.835, 121.125, 123.071,
    122.314, 111.229, 104.537, 114.572, 111.337, 111.488, 126.728, 126.663,
    123.304, 117.372, 118.291, 122.779, 124.533, 124.794, 130.603, 114.907,
    111.555, 113.108, 122.084, 121.533, 127.231, 136.978, 119.283, 122.358,
    120.857, 120.042, 118.507, 112.69, 106.428, 105.82, 113.12, 103.767,
    103.486, 106.057, 117.079, 117.672, 115.959, 110.676, 105.633, 112.709,
    116.023, 119.895, 120.841, 116.036, 111.087, 109.591, 108.56, 114.912,
    120.508, 117.97, 114.654, 110.934, 111.486, 111.769, 109.32, 114.155,
    113.404, 111.912, 111.321, 113.648, 110.729, 114.926, 118.211, 118.092,
    111.359, 111.662, 111.437, 106.402, 99.815, 112.397, 110.306, 100.305,
    100.266, 98.282, 103.793, 103.804, 118.879, 113.722, 98.135, 95.678,
    103.778, 115.179,
  ],
  p95: [
    104.271, 101.903, 101.763, 102.614, 97.124, 106.667, 136.472, 152.831,
    160.262, 151.305, 140.177, 130.947, 143.492, 143.503, 141.499, 162.933,
    159.966, 162.908, 144.964, 148.42, 155.016, 160.301, 161.293, 167.261,
    144.123, 143.408, 140.165, 155.305, 155.38, 173.54, 186.736, 160.521,
    155.297, 153.205, 154.86, 150.952, 145.95, 133.767, 134.086, 146.623,
    130.272, 131.084, 137.376, 150.925, 150.257, 148.606, 142.657, 136.612,
    146.823, 144.913, 153.641, 155.65, 146.879, 140.816, 141.253, 142.358,
    151.528, 154.803, 150.418, 141.367, 142.448, 141.777, 142.736, 140.685,
    148.053, 143.927, 139.273, 151.459, 145.258, 141.791, 148.732, 159.167,
    152.363, 142.671, 151.139, 143.476, 136.821, 128.902, 138.225, 138.875,
    133.478, 128.185, 124.966, 129.241, 131.503, 154.075, 143.752, 127.013,
    122.848, 136.246, 147.883,
  ],
  p99: [
    156.185, 144.14, 141.883, 156.452, 156.56, 181.58, 212.11, 230.666, 233.928,
    216.161, 220.3, 222.041, 220.599, 214.978, 211.023, 227.918, 222.752,
    218.75, 219.073, 222.135, 225.086, 235.373, 238.884, 853.046, 212.623,
    210.559, 219.388, 230.831, 234.825, 247.052, 276.07, 243.223, 236.164,
    227.837, 230.52, 219.635, 206.739, 200.066, 199.505, 226.224, 197.112,
    201.626, 216.121, 216.512, 207.273, 219.987, 212.628, 212.225, 223.563,
    211.265, 214.957, 222.803, 226.429, 224.178, 213.853, 213.95, 218.873,
    216.23, 212.651, 212.595, 213.844, 217.937, 212.212, 222.982, 210.202,
    201.475, 213.481, 222.891, 216.714, 211.493, 222.835, 220.175, 219.872,
    209.724, 221.957, 213.29, 203.738, 209.589, 223.961, 217.762, 224.219,
    212.943, 206.863, 213.564, 214.52, 233.556, 218.767, 211.768, 204.485,
    292.54, 223.119,
  ],
  satisfied: [
    312558, 254793, 304678, 551243, 485805, 408032, 506224, 487736, 271667,
    314981, 417895, 363223, 543881, 541878, 471021, 303756, 308573, 423252,
    589947, 554260, 535504, 499603, 245540, 307438, 518433, 570733, 590508,
    541561, 453205, 159103, 114515, 416702, 545416, 552204, 505393, 476159,
    217414, 312822, 655641, 628286, 597365, 519358, 454166, 234615, 271227,
    546904, 531821, 546363, 498711, 483154, 315901, 320895, 543504, 528468,
    539486, 374099, 411418, 275514, 257996, 523664, 493370, 555686, 513536,
    476335, 240270, 250825, 526327, 519806, 535649, 468154, 458120, 256903,
    305856, 487143, 560590, 572101, 446379, 260250, 91161, 100618, 293968,
    346242, 350956, 337033, 287637, 95323, 103770, 220671, 338010, 417117,
    321046,
  ],
  tolerating: [
    187, 120, 114, 346, 322, 317, 340, 385, 143, 159, 418, 460, 355, 311, 342,
    287, 125, 218, 515, 431, 365, 355, 286, 796, 363, 557, 345, 409, 430, 183,
    180, 501, 381, 391, 390, 408, 142, 147, 460, 475, 462, 466, 461, 183, 152,
    355, 617, 416, 426, 491, 187, 174, 376, 479, 479, 261, 380, 166, 156, 418,
    305, 306, 420, 373, 156, 132, 386, 369, 310, 330, 340, 229, 209, 329, 357,
    297, 353, 368, 153, 139, 349, 358, 296, 358, 372, 177, 193, 304, 312, 1248,
    228,
  ],
  frustrated: [
    74, 87, 71, 91, 112, 98, 125, 139, 90, 66, 119, 161, 134, 98, 113, 96, 71,
    91, 114, 133, 121, 207, 103, 2223, 136, 141, 135, 107, 165, 63, 56, 99, 107,
    119, 112, 114, 89, 55, 121, 134, 117, 133, 190, 85, 65, 131, 115, 129, 137,
    113, 69, 95, 146, 1127, 113, 68, 106, 44, 61, 101, 105, 98, 78, 96, 49, 40,
    106, 77, 78, 112, 120, 85, 81, 105, 84, 89, 135, 111, 80, 59, 108, 249, 180,
    112, 139, 81, 42, 72, 120, 2210, 99,
  ],
} as any;
